import { useState } from "react";
import { useAuthContext } from "./adminAuthHook";
import toast from "react-hot-toast";

export default function LoginHook() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { dispatch } = useAuthContext();
  const [isLoading, setLoading] = useState(false);
  const storeUserData = (key, data, rememberMe) => {
    if (rememberMe) {
      localStorage.setItem(key, JSON.stringify(data));
    } else {
      sessionStorage.setItem(key, JSON.stringify(data));
    }
  };
  // Fetching API endpoint to register a new seller
  const adminLogin = async (contact, password,rememberMe) => {
    toast.promise(
      new Promise(async (resolve, reject) => {
        try {
          setLoading(true);
          const response = await fetch(`${apiUrl}/api/admin/login`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ email: contact, password }),
          });

          const json = await response.json();

          if (response.ok) {
            resolve(json.message);
            storeUserData('admin', json, rememberMe);
            dispatch({ type: "ADMIN_LOGIN", payload: json });
          } else {
            reject(new Error(json.message || "Login failed.")); // Use actual API message for error
          }
        } catch (error) {
          reject(new Error(error.message || "Unexpected error occurred.")); // Handle unexpected errors
        } finally {
          setLoading(false);
        }
      }),
      {
        loading: "Logging you in...",
        success: (message) => <b>{message || "Login successfully!"}</b>, // Use dynamic message for success
        error: (error) => <b>{error.message || "Failed to Login."}</b>, // Use dynamic message for error
      }
    );
  };

  return { isLoading, adminLogin };
}
